class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isLanguageModal = this.classList.contains('header-language-modal');
    this.languageModalPanel = this.isLanguageModal ? this.querySelector('.language-modal') : null;
    this.portalPlaceholder = null;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (this.summaryToggle.contains(event.target)) return;

    const panel = this.languageModalPanel;
    const clickedInsidePanel = panel && panel.contains(event.target);
    const clickedInsideComponent = this.contains(event.target);

    if (
      (!clickedInsideComponent && !clickedInsidePanel) ||
      event.target.classList.contains('modal-overlay')
    ) {
      this.close(false);
    }
  }

  setLanguageModalVisible(visible) {
    if (!this.languageModalPanel) return;

    this.languageModalPanel.classList.toggle('language-modal--open', visible);
    document.body.classList.toggle('language-modal-is-open', visible);
  }

  portalLanguageModal() {
    if (!this.languageModalPanel) return;

    const panel = this.languageModalPanel;

    if (panel.parentElement !== document.body) {
      this.portalPlaceholder = document.createComment('language-modal-placeholder');
      panel.parentNode.insertBefore(this.portalPlaceholder, panel);
      document.body.appendChild(panel);
      panel.dataset.portaled = 'true';
    }

    this.setLanguageModalVisible(true);
  }

  unportalLanguageModal() {
    if (!this.languageModalPanel) return;

    const panel = this.languageModalPanel;

    this.setLanguageModalVisible(false);

    if (panel.dataset.portaled !== 'true') return;

    if (this.portalPlaceholder?.parentNode) {
      this.portalPlaceholder.parentNode.insertBefore(panel, this.portalPlaceholder);
      this.portalPlaceholder.remove();
      this.portalPlaceholder = null;
    } else if (panel.parentElement === document.body) {
      this.detailsContainer.appendChild(panel);
    }

    delete panel.dataset.portaled;
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    if (this.isLanguageModal) {
      this.portalLanguageModal();
    }

    const focusContainer =
      this.detailsContainer.querySelector('[tabindex="-1"]') ||
      this.languageModalPanel?.querySelector('[tabindex="-1"]') ||
      this.detailsContainer;
    let elementToFocus = this.detailsContainer.querySelector('input:not([type="hidden"])');

    if (!elementToFocus) {
      const searchRoot = this.languageModalPanel || this.detailsContainer;
      elementToFocus =
        searchRoot.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') ||
        focusContainer;
    }

    trapFocus(focusContainer, elementToFocus);

    clearTimeout(this.bodyClickTimeout);
    this.bodyClickTimeout = setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);
  }

  close(focusToggle = true) {
    clearTimeout(this.bodyClickTimeout);
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);

    if (this.isLanguageModal) {
      this.unportalLanguageModal();
    }

    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
